export default class ISaveModel {
    
    constructor() {
    }

    createSaveGame() {
        throw new Error("Method not implemented.");
    }

    setSaveGame() {
        throw new Error("Method not implemented.");
    }
};
